import { Component, OnInit,Inject,PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-app-tabs-route',
  templateUrl: './app-tabs-route.component.html',
  styleUrls: ['./app-tabs-route.component.scss']
})
export class AppTabsRouteComponent implements OnInit {
  css:string;
  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit() {
  }
  onActivate(event: any) {
    if (isPlatformBrowser(this.platformId)) {
      let scrollToTop = window.setInterval(() => {
        let pos = window.pageYOffset;
        if (pos > 0) {
          window.scrollTo(0, pos - 50);
        } else {
          window.clearInterval(scrollToTop);
        }
      }, 16);
    }
  }

}
